import BrandChoicePanel from './BrandChoicePanel'

export default BrandChoicePanel
